import React, { useState } from "react";
import hide from "../../assets/images/secretManagement/hide.svg";
import show from "../../assets/images/secretManagement/show.svg";
import darkShow from "../../assets/images/createPassword/darkShow.svg";
import darkHide from "../../assets/images/createPassword/darkHide.svg";
import copyImage from "../../assets/images/secretManagement/copy.svg";
import copyImageDark from "../../assets/images/dropdown/copyDark.svg";
import useTheme from "hooks/observer";
import useScreenMobile from "hooks/useScreen";
import "./copyPassword.scss";
import { useToast } from "components/Toaster/index";

const CopyPassword = ({
  onChange = () => {},
  value = "",
  error,
  inputWidth = "370px",
  errorMessage = "",
  mockClass
}) => {
  const isMobile = useScreenMobile({ size: 992 });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [, setCopySuccess] = useState(false);
  const theme = useTheme();
  const showToast = useToast();

  const hideImage = theme === "light" ? hide : darkShow;
  const showImage = theme === "light" ? show : darkHide;

  const handlePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopySuccess(true);
      showToast("Copied Successfully", "success");
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy password:", err);
    }
  };

  return (
    <div
      className="copyPassword"
      style={{ width: isMobile ? inputWidth : inputWidth }}
    >
      <>
        <input
          style={{
            border: errorMessage ? "1px solid  var(--accent-colors-red)" : "",
            WebkitTextSecurity: !showPassword ? "square" : ""
          }}
          value={value}
          onChange={onChange}
          type={showPassword ? "text" : "password"}
          placeholder="Enter your password"
          className={`passwordInput ${mockClass}`}
        />
        <button
          onClick={() => setShowPassword(!showPassword)}
          className="toggleButton"
          type="button"
        >
          <img
            src={isPasswordVisible ? showImage : hideImage}
            alt=""
            onClick={handlePasswordVisibility}
          />
          <img
            src={theme == "light" ? copyImage : copyImageDark}
            alt=""
            onClick={handleCopy}
          />
        </button>
        {errorMessage && <p className="errorMessage">{errorMessage}</p>}
      </>
    </div>
  );
};

export default CopyPassword;
